<div class="d-flex justify-content-between">
    <h2 mat-dialog-title class="bg-white flex-fill">
        @switch (topic.type){
            @case ('question'){
                <i class="fa-regular fa-messages-question pe-2"></i>
                <span>{{'question-request-modal.title' | translate}}</span>
            }
            @case ('issue'){
                <i class="fa-regular fa-message-exclamation pe-2"></i>
                <span>{{'issue-request-modal.title' | translate}}</span> 
            }
        }
    </h2>
    <mat-dialog-actions>
      <button type="button" class="btn p-0 border-0 fs-4 text-secondary" (click)="onClose()"><i
          class="fa-regular fa-xmark"></i></button>
    </mat-dialog-actions>
  </div>
  
  <mat-dialog-content class="dialog-content-pad-15 py-1 px-0">
    <mat-stepper [linear]="false" #stepper [orientation]="(stepperOrientation | async)!" (selectionChange)="onChange($event)">
      <ng-template matStepperIcon="edit">
        <i class="fa-solid fa-check"></i>
      </ng-template>
  
  <!-- Step 1 : Intro -->
    @if(showIntro){
    <mat-step>
        <ng-template matStepLabel>Intro</ng-template>
        <ng-template matStepContent>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form text-secondary topic-intro">
                    @switch (topic.type){
                        @case ('question'){
                            <h3 class="pt-3 pb-2">{{'topic-question.creation-dialog.intro_title' | translate}}</h3>
                            <p class="pb-2">{{'topic-question.creation-dialog.intro_desc1' | translate}}</p>
                            <ul>
                                <li><strong>{{'topic-question.creation-dialog.intro_desc3' | translate}}</strong> {{'topic-question.creation-dialog.intro_desc3.1' | translate}}</li>
                                <li><strong>{{'topic-question.creation-dialog.intro_desc4' | translate}}</strong> {{'topic-question.creation-dialog.intro_desc4.1' | translate}}</li>
                                <li><strong>{{'topic-question.creation-dialog.intro_desc5' | translate}}</strong> {{'topic-question.creation-dialog.intro_desc5.1' | translate}}</li>
                            </ul>
                            <p class="py-2">{{'topic-question.creation-dialog.intro_ready' | translate}}</p>
                        }
                        @case ('issue'){
                            <h3 class="pt-3 pb-2">{{'topic-issue.creation-dialog.intro_title' | translate}}</h3>
                            <p class="pb-2">{{'topic-issue.creation-dialog.intro_desc1' | translate}}<strong> {{'topic-issue.creation-dialog.intro_desc1.1' | translate}}</strong> {{'topic-issue.creation-dialog.intro_desc1.2' | translate}}</p>
                            <p class="pb-2">{{'topic-issue.creation-dialog.intro_desc2' | translate}}</p>
                            <ul>
                                <li><strong>{{'topic-issue.creation-dialog.intro_desc3' | translate}}</strong> {{'topic-issue.creation-dialog.intro_desc3.1' | translate}}</li>
                                <li><strong>{{'topic-issue.creation-dialog.intro_desc4' | translate}}</strong> {{'topic-issue.creation-dialog.intro_desc4.1' | translate}}</li>
                                <li><strong>{{'topic-issue.creation-dialog.intro_desc5' | translate}}</strong> {{'topic-issue.creation-dialog.intro_desc5.1' | translate}}</li>
                            </ul>
                            <p class="py-2">{{'topic-issue.creation-dialog.intro_ready' | translate}}</p>
                        }
                    }
                </div>
                @if((stepperOrientation | async)! === 'horizontal'){
                  <div class="col-md-6">
                      <div class="d-flex justify-content-center align-items-center">
                        <img src="/assets/images/add_comment/talking-people.svg" alt="" width="300" class="pt-md-5">
                      </div>
                  </div>
                }
            </div>

            <div class="step-navigation">
                <div class="pb-2">
                    <label>
                        <input type="checkbox" [formControl]="dontShowAgainCtrl" [checked]="dontShowAgainCtrl.value"> {{'topic.creation-dialog.dont_show_again' | translate}}
                    </label>
                </div>
                <div>
                    <button ngClass="btn btn-primary" mat-button matStepperNext data-cy="continueToCreate">{{'poll_creation.continue' | translate}}<i class="fa-solid fa-caret-right ps-1"></i></button>
                </div>
            </div>
        </ng-template>
    </mat-step>
    } 
  
  <!-- Step 2 : Create -->
      <mat-step label="Create" [stepControl]="topicMessageCtrl" errorMessage="Content is required.">
        <ng-template matStepLabel>{{'topic.creation-dialog.create' | translate}}</ng-template>
        <ng-template matStepContent>
          <form>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form pt-2">
                    <label for="topic-input" class="form-label">
                        @switch (topic.type){
                            @case ('question'){
                                {{'topic-question.creation-dialog.type_title' | translate }}
                            }
                            @case ('issue'){
                                {{'topic-issue.creation-dialog.type_title' | translate }}
                            }
                        }
                    </label>
                    <form class="moodpickers-wrapper">
                        @if(topic?.title?.body){
                            <button class="delete-comment-button"
                                    type="button"
                                    aria-label="delete topic message"
                                    (click)="updateMessage('')">
                                <i class="fa fa-times"></i>
                            </button>
                        }
                        <textarea class="form-control"
                                  id="topic-input"
                                  name="title"
                                  [formControl]='topicMessageCtrl'
                                  rows="5"
                                  [placeholder]="topicPlaceholder | translate"></textarea>
                        <tm-mood-pickers (onElement)="fromMoodPicker($event)"></tm-mood-pickers>
                    </form>
                
                    <div class="disclaimer-area user-request-modal-body-text">
                        <p><small>{{'add_comment_informations_disclaimer' | translate}} <a
                                href="/{{teamId}}/codeofconduct"
                                target="_blank">{{'add_mood_box.code_of_conduct' | translate}}</a>.</small>
                        </p>
                    </div>

                    <!-- <p class="form-text text-danger message-error">
                        @if(topicMessageCtrl.invalid && topicMessageCtrl.touched){
                            {{'topic.creation-dialog.no_message' | translate}}
                        }
                    </p> -->
                    
                    @if(topic.type === 'question'){
                        <div class="my-2">
                            <p class="mt-2 text-secondary">
                                <i class="fa-light fa-comment-dots pe-1"></i><em>{{'topic-request-modal.suggestions' | translate}}</em>
                            </p>
                            <div>
                                @for(questionSuggestion of questionSuggestions; track questionSuggestion.type){
                                <button class="btn btn-outline-secondary py-0 my-1 me-1"
                                        (click)="updateQuestionType(questionSuggestion.type)"
                                        [ngClass]="{'active': topic.questionType == questionSuggestion.type}">{{questionSuggestion.typeName | translate}}</button>
                                }
                            </div>
                            @if (topic.questionType) {
                                <template-list [templates]="questions()" 
                                               [timelineItemContent]="topic.title.body"
                                               (onSelect)="updatePlaceholder($event)"></template-list>
                            }
                        </div>
                    }
                </div>
  
              @if((stepperOrientation | async)! === 'horizontal'){
                <div class="col-md-6 preview">
                    <topic-preview [topic]="topic"
                                   [title]="topic.title.body"
                                   [userInfos]="userInfos"
                                    state="customize"></topic-preview>
                </div>
              }
            </div>
            <div class="step-navigation">
              <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button> -->
              <button ngClass="btn btn-primary" data-cy="continueToNotify" mat-button matStepperNext
                [disabled]="topicMessageCtrl.invalid">{{'poll_creation.continue' | translate}}<i
                  class="fa-solid fa-caret-right ps-1"></i></button>
            </div>
          </form>
  
        </ng-template>
      </mat-step>
  
    <!-- Step 2 : Notify? -->
@if(!shouldNotNotifyOnTopicCreation){
    <mat-step label="Notify?" [stepControl]="notifyOnTopicCreationCtrl" errorMessage="Field required.">
        <ng-template matStepLabel>{{'topic.creation-dialog.notify' | translate}}</ng-template>
        <ng-template matStepContent>
          <form>
            <div class="row step-content step-content py-3 px-4 gx-4">
                <div class="col-md-6 form pt-2 d-flex flex-column justify-content-between">
                    <div class="pt-4 row">
                        <label class="col-sm-7 col-form-label form-stepper-label"
                                for="toggleAllowComments">{{'topic.creation-dialog.notify.label' | translate}}</label>
                        <div class="col-sm-5 pt-3 d-flex">
                          <div class="indicator">
                            <span class="pe-2">{{'No' | translate}}</span>
                          </div>
                          <tm-slide-toggle id="toggleAllowComments" [formControl]="notifyOnTopicCreationCtrl"></tm-slide-toggle>
                          <div class="indicator">
                            <span class="ps-2"> {{'Yes' | translate}}</span>
                          </div>
                        </div>
                    </div>
                    <div class="form-step-description">
                        <div class="alert alert-success mb-0" role="alert">
                          <i class="far fa-info-circle"></i> {{'topic.creation-dialog.notify.desc' | translate}}
                          {{'topic.creation-dialog.notify.desc1' | translate}}
                        </div>
                      </div>

                </div>
  
              @if((stepperOrientation | async)! === 'horizontal'){
                <div class="col-md-6 preview">
                    <topic-preview [topic]="topic"
                                   [userInfos]="userInfos"
                                   [notify]="notifyOnTopicCreationCtrl.value"
                                    state="notify"></topic-preview>
                </div>
              }
            </div>
            <div class="step-navigation">
              <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button> -->
              <button ngClass="btn btn-primary" data-cy="continueToPublish" mat-button matStepperNext
                [disabled]="topicMessageCtrl.invalid">{{'poll_creation.continue' | translate}}<i
                  class="fa-solid fa-caret-right ps-1"></i></button>
            </div>
          </form>
  
        </ng-template>
      </mat-step>
}
  
  <!-- Final Step : Review and Publish -->
      <mat-step>
        <ng-template matStepLabel>{{'poll_creation.publish' | translate}}</ng-template>
        <ng-template matStepContent>
          <div class="row step-content py-3 px-4 gx-4">
            <div class="col-md-6 form text-center">
              <p class="form-stepper-label">{{'topic.creation-dialog.publish_desc1' | translate}}</p>
              <p>{{'topic.creation-dialog.publish_desc2' | translate }}</p>
            </div>
            @if((stepperOrientation | async)! === 'horizontal'){
            <div class="col-md-6 preview">
                <topic-preview [topic]="topic"
                               [userInfos]="userInfos"
                               [notify]="notifyOnTopicCreationCtrl.value"
                               state="publish"></topic-preview>
            </div>
            }
          </div>
          <div class="step-navigation">
            <!-- <button ngClass="btn btn-outline-primary" mat-button matStepperPrevious>Back</button>             -->
            <!--               [disabled]="scheduleFormGroup.invalid || targetFormGroup.invalid || customizeFormGroup.invalid"
 -->
            <button class="btn btn-primary" data-cy="publishTopic" mat-button
              (click)="createTopic()">{{'poll_creation.publish' | translate}}</button>
          </div>
        </ng-template>
  
      </mat-step>
    </mat-stepper>
  </mat-dialog-content>